
import { defineComponent, ComputedRef, reactive, Ref, ref, onMounted, onUnmounted, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'

import { CheckCircleOutlined, LoadingOutlined, ExclamationCircleOutlined } from '@ant-design/icons-vue'

import { Props, validateInfos } from 'ant-design-vue/lib/form/useForm'
import { message, Form } from 'ant-design-vue'
const useForm = Form.useForm
import useI18nAntdFormVaildateInfos from '@/composables/useI18nAntdFormVaildateInfos'
import {isPassword} from '@/utils/validate'

import { StateType as SetPasswordStateType} from './store'
import {StateType as VerifyEmailStateType} from '../activation/store'

import {gotoEmail} from '@/utils/gotoemail'

interface ModifyPassword {
    newPassword: string;
    newPassword2: string;
}

interface ActivationEmailSetupData {
    t: (key: string | number) => string;
    validateInfos: ComputedRef<validateInfos>;
    modelRef: ModifyPassword;
    email: Ref<string>;
    loading: Ref<boolean>;
    isShow: Ref<boolean>;
    isflag: Ref<boolean>;
    isFlag: Ref<boolean>;
    isCheck: Ref<boolean>;
    count: Ref<number>;
    resetFields: (newValues?: Props) => void;
    handleBack: (e: MouseEvent) => void;
    handleGoToEmail: (e: MouseEvent) => void;
    handleSubmit: (e: MouseEvent) => void;
}

export default defineComponent({
    name: 'ActivationEmail',
    components: {
        CheckCircleOutlined,
        LoadingOutlined,
        ExclamationCircleOutlined
    },
    setup():ActivationEmailSetupData {
        const route = useRoute()
        const router = useRouter()
        const store = useStore<{setPassword:SetPasswordStateType,verifyemail:VerifyEmailStateType}>()
        const email = ref<string>('')
        const isShow = ref<boolean>(false)
        const loading = ref<boolean>(false)
        const isflag = ref<boolean>(true)
        const isFlag = ref<boolean>(false)
        const isCheck = ref<boolean>(true)
        const count = ref<number>(3)
        const { t } = useI18n()
        const handleBack = () => {
            router.replace('/user/login')
        }
        const handleGoToEmail = (e: MouseEvent) => {
            e.preventDefault()
            const emSuffix = `@${email.value?.split('@')[1]}`
            gotoEmail(emSuffix)
        }

        const isRouteP = () => {
            if(route?.query?.u&&route?.query?.k&&route?.query?.t){
                isFlag.value = true
                isflag.value = false
                isShow.value = false
                const k = route?.query?.k ?? ''
                const t = route?.query?.t ?? ''
                const u = route?.query?.u ?? ''
                const params = {
                    emailKey: k,
                    type: t,
                    userCode: u
                }
                verifyemailFn(params)
            }
        }

        //校验
        const info = computed<any>(() => store.state.verifyemail.info)
        const verifyemailFn = async(params:any) => {
            try {
                const res:boolean = await store.dispatch('verifyemail/verifyEmailFn',params)
                if(res===true){
                    email.value = info.value.email
                    isCheck.value = true
                }else{
                    isCheck.value = false
                }
            } catch (error) {
                message.warning('error=>'+error)
            }
        }

        const countDown = () => {
            const time = setInterval(()=>{
                count.value--
                if(count.value<=0){
                    clearInterval(time)
                    router.replace('/user/login')
                }
            },1000)
        }

        //表单数据
        const modelRef = reactive<ModifyPassword>({
            newPassword: '',
            newPassword2: ''
        })
        const rulesRef = reactive({
            newPassword: [
                {
                    required: true,
                    validator: (rule: any, value: string, callback: any)=>{
                        if(value == '' || value == undefined){
                            return Promise.reject('请输入新密码')
                        }else if(!isPassword(value)){
                            return Promise.reject('密码为6-20位大小写字母、数字或符号的至少两种组合的密码')
                        }else{
                            return Promise.resolve()
                        }
                    }
                }
            ],
            newPassword2: [
                {
                    required: true,
                    validator: (rule: any, value: string, callback: any)=>{
                        if(value == '' || value == undefined){
                            return Promise.reject('请输入新密码')
                        }else if(!isPassword(value)){
                            return Promise.reject('密码为6-20位大小写字母、数字或符号的至少两种组合的密码')
                        }else if(value && modelRef.newPassword && value !== modelRef.newPassword){
                            return Promise.reject('设置新密码与确认新密码不一致，请重新输入!')
                        }else{
                            return Promise.resolve()
                        }
                    }
                }
            ]
        })
        const { resetFields, validate, validateInfos } = useForm(modelRef, rulesRef);
        const handleSubmit = async(e: MouseEvent) => {
            e.preventDefault()
            loading.value = true
            try {
                const fieldsValue = await validate<ModifyPassword>()
                fieldsValue['email'] = info.value.email
                const res:boolean = await store.dispatch('setPassword/getPasswordByEmailFn', fieldsValue)
                if(res === true){
                    isShow.value = true
                    isflag.value = false
                    isFlag.value = false
                    countDown()
                }
            } catch (error) {
                message.warning('校验不过通过')
            }
            loading.value = false
        }
        // 重置 validateInfos
        const validateInfosNew = useI18nAntdFormVaildateInfos(validateInfos);


        onMounted(()=>{
            isRouteP()
        })

        onUnmounted(()=>{
            localStorage.removeItem('getEmail')
        })

        return {
            t,
            email,
            isShow,
            loading,
            isflag,
            isFlag,
            isCheck,
            count,
            validateInfos: validateInfosNew,
            modelRef,
            resetFields,
            handleBack,
            handleGoToEmail,
            handleSubmit
        }
    }
})
